(function () {
  var STORAGE_KEY = 'mm_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {}
  }

  function syncButtonState(button, handles) {
    var active = handles.indexOf(button.dataset.productHandle) !== -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function refreshButtons(root) {
    var handles = getWishlist();
    (root || document).querySelectorAll('.mm-wishlist-btn').forEach(function (button) {
      syncButtonState(button, handles);
    });
    updateCount(handles);
  }

  function updateCount(handles) {
    var count = (handles || getWishlist()).length;
    document.querySelectorAll('.mm-wishlist-count').forEach(function (el) {
      el.textContent = count > 0 ? String(count) : '';
      el.hidden = count === 0;
    });
  }

  function toggleHandle(handle) {
    var handles = getWishlist();
    var index = handles.indexOf(handle);
    if (index === -1) {
      handles.push(handle);
    } else {
      handles.splice(index, 1);
    }
    setWishlist(handles);
    return handles;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.mm-wishlist-btn');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var handle = button.dataset.productHandle;
    var handles = toggleHandle(handle);

    document.querySelectorAll('.mm-wishlist-btn[data-product-handle="' + handle + '"]').forEach(function (matchedButton) {
      syncButtonState(matchedButton, handles);
    });
    updateCount(handles);

    document.dispatchEvent(new CustomEvent('mm:wishlist:change', { detail: { handles: handles } }));

    var grid = document.getElementById('mm-wishlist-grid');
    if (grid && handles.indexOf(handle) === -1) {
      var card = grid.querySelector('[data-wishlist-handle="' + handle + '"]');
      if (card) card.remove();
      if (window.mmRenderWishlistEmptyStateIfNeeded) window.mmRenderWishlistEmptyStateIfNeeded();
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    refreshButtons();
  });

  document.addEventListener('shopify:section:load', function () {
    refreshButtons();
  });

  window.mmWishlist = {
    get: getWishlist,
    refreshButtons: refreshButtons,
  };
})();
